import React from 'react';
import dayjs from 'dayjs';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import { styled } from '@mui/material/styles';
import TableBasicLabel from '../../common/labels/TableBasicLabel/TableBasicLabel';
import StatusColorPoint from '../../common/labels/StatusColorPoint/StatusColorPoint';
import ThreeDotMenu from '../../common/ThreeDotMenu/ThreeDotMenu';
import { getFirstDayOFMonth, getLastDayOFMounth } from '../../../utils/helpers';
import { monthsShort, timesheetsStatuses } from '../../../utils/constants';
import { submissionEnum } from '../../../utils/enums';
import colors from '../../../scss/colors';
// import { Select } from '@mui/material';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
// import MenuItem from '@mui/material/MenuItem';
// import { styled } from '@mui/material/styles';
// import EditableLable from '../../../common/labels/EditableLabel/EditableLable';
// import TableBasicLabel from '../../../common/labels/TableBasicLabel/TableBasicLabel';
// import { getNumberWithDelimeter } from '../../../../utils/helpers';
// import { getHoursByDate } from '../helpers';
// import AddGradientIcon from '../../../common/Icons/AddGradientIcon';
// import TimesheetComment from './TimesheetComment/TimesheetComment';

const styleConfig = {
  month: { width: { min: '48px', max: '48px' } },
  client: { width: { min: '132px', max: '200px' } },
  record: { width: { min: '160px', max: '160px' } },
  status: { width: { min: '150px', max: '150px' } },
  threedot: { width: { min: '40px', max: '40px' } }
};

const ThreeDotContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: '24px'
}));

const ThreeDotItem = styled('p')(() => ({
  fontStyle: 'normal',
  fontWeight: 325,
  fontSize: '20px',
  lineHeight: '24px',
  color: colors.MEDIUM_GREY,
  cursor: 'pointer'
}));

const timesheetPeriod = (data, t) => {
  if (data?.TimesheetType.split('-')[0].toLowerCase() === submissionEnum.MONTHLY) {
    const currentDay = data.TimesheetDetails[0].TimesheetHoursByDates[7]?.Day;

    if (currentDay) {
      return `${getFirstDayOFMonth(currentDay).getDate()} - ${getLastDayOFMounth(currentDay).getDate()} ${
        monthsShort(t)[
          new Date(
            data?.TimesheetDetails[0].TimesheetHoursByDates.find((item) => new Date(item?.Day).getDate() === 1)?.Day
          ).getMonth()
        ]
      } ${new Date(currentDay).getFullYear()}`;
    }

    return '-';
  }

  if (!data?.TimesheetDetails.length) return '-';

  const dates = data?.TimesheetDetails[0]?.TimesheetHoursByDates;
  let minDate = '';
  let maxDate = '';

  if (dates.length) {
    minDate = data?.TimesheetDetails[0]?.TimesheetHoursByDates[0].Day;
    maxDate = data?.TimesheetDetails[0]?.TimesheetHoursByDates.at(-1).Day;
  }

  if (dates.length === 1) {
    return `${dayjs(minDate.Day).date()} - ${dayjs(minDate.Day).format('MMM')} ${dayjs(minDate.Day).format('YYYY')}`;
  }

  if (dates.length > 1) {
    return `${dayjs(minDate).date()} - ${dayjs(maxDate).date()} ${dayjs(maxDate).format('MMM')} ${dayjs(maxDate).format(
      'YYYY'
    )}`;
  }

  return '-';
};

const columns = (t, navigate, copyHandler, deleteHandler, isApprover) => {
  return [
    {
      id: 'week',
      name: () => (
        <TableBasicLabel
          text={t('dashboard.timesheets.table.workperiod')}
          fontColor="white"
          withForceBrake="max-content"
        />
      ),
      alignment: 'flex-start',
      value: (data) => (
        <TableBasicLabel
          text={timesheetPeriod(data, t)}
          fontColor={colors.NAVY_BLUE}
          fontSize="20px"
          lineHeight="24px"
          fontWeight={600}
          withForceBrake="max-content"
        />
      ),
      footer: () => {}
    },
    {
      id: 'client',
      name: () => (
        <TableBasicLabel
          text={isApprover ? t('dashboard.timesheets.table.contractor') : t('dashboard.timesheets.table.client')}
          fontColor="white"
          withForceBrake="max-content"
        />
      ),
      alignment: 'flex-start',
      value: (data) => (
        <TableBasicLabel
          text={isApprover ? `${data?.User?.FirstName} ${data?.User?.LastName}` : data?.ClientName}
          fontColor={colors.PRIMARY_BLUE}
          fontSize="16px"
          lineHeight="19px"
          fontWeight={325}
          withForceBrake="max-content"
          isTruncate
        />
      ),
      footer: () => {}
    },
    {
      id: 'record',
      width: styleConfig.record.width,
      alignment: 'flex-start',
      name: () => (
        <TableBasicLabel text={t('dashboard.timesheets.table.record')} fontColor="white" withForceBrake="max-content" />
      ),
      value: (data) => (
        <TableBasicLabel
          text={data?.RecordNo}
          fontColor={colors.MEDIUM_GREY}
          fontSize="12px"
          lineHeight="14px"
          fontWeight={325}
          withForceBrake="max-content"
        />
      ),
      footer: () => {}
    },
    {
      id: 'status',
      width: styleConfig.status.width,
      alignment: 'flex-start',
      name: () => (
        <TableBasicLabel text={t('dashboard.timesheets.table.status')} fontColor="white" withForceBrake="max-content" />
      ),
      value: (data) => <StatusColorPoint status={data?.Status?.Status.toLowerCase()} isApprover={isApprover} />,
      footer: () => {}
    },
    {
      id: 'threedot',
      width: styleConfig.threedot.width,
      alignment: 'flex-end',
      name: () => ' ',
      value: (data) =>
        !isApprover && (
          <ThreeDotMenu menuComponent={<MoreVertOutlinedIcon sx={{ color: '#A3B4C7', fontSize: '24px' }} />}>
            <ThreeDotContainer>
              <ThreeDotItem onClick={() => copyHandler(data.Id)}>
                {t('dashboard.timesheets.threedot.copy')}
              </ThreeDotItem>
              {data.Status.Status === timesheetsStatuses(t).draft.apiStatus && (
                <ThreeDotItem onClick={() => deleteHandler(data.Id)}>
                  {t('dashboard.timesheets.threedot.delete')}
                </ThreeDotItem>
              )}
            </ThreeDotContainer>
          </ThreeDotMenu>
        ),
      footer: () => {}
    }
  ];
};

export { columns, timesheetPeriod };
